import styled from "styled-components"

export const Button = styled.button`
  border-radius: 25px;
  background-color: blue;
  cursor: pointer;
  color: #fff;
  border: none;
  padding: 10px 20px 10px 20px;
  //width:10vw;
  //min-width:80px;
  font-size:15px;
  font-weight:600;
  &:hover{
    background-color: #3d4f7c;
  }
`